<template>
  <div class="property_index">
    <div class="property_index_search">
      <div class="property_index_search_input">
        <div style="width: 850px;">
          <el-input
            placeholder="请输入或选择查询内容"
            prefix-icon="el-icon-search"
            v-model="searchData"
            @input="inputValueChange"
            @focus="getValueMethods"
            style="border-radius:100px;">
            <!-- <el-button
              size="mini"
              style="line-height: 26px;"
              slot="suffix"
              type="text"
              @click="dialogManager = true">
            选择
            </el-button> -->

            <el-select v-model="selectSearchData" slot="prepend" placeholder="请选择搜索条件" style="border-left: 0px; width: 230px;" @change="resetForm('SForm')">
              <el-option label="根据资产名称查询" value="1"></el-option>
              <el-option label="根据使用人姓名ID查询" value="2"></el-option>
              <el-option label="根据资产固定编码查询" value="3"></el-option>
              <el-option label="根据类别查询" value="4"></el-option>
              <el-option label="根据存放的区域查询" value="5"></el-option>
              <el-option label="根据单位查询" value="6"></el-option>
              <el-option label="根据是否为帐外资产查询" value="7"></el-option>
              <el-option label="根据资产状态查询" value="8"></el-option>
            </el-select>
          </el-input>
        </div>
        <el-button type="text"  @click="select(1)" style="font-size: 16px; color: #121212; margin-left: 24px;">查询</el-button>
        <el-button type="text"  @click="resetForm('SForm')" style="font-size: 16px; color: #121212; margin-left: 24px;">重置</el-button>
        <!-- <div >查询</div> -->
        <!-- <div class="property_index_search_input_text" @click="resetForm('SForm')">重置</div> -->
      </div>

      <el-dialog title="选择查询人员" :visible.sync="dialogManager" width="35%">
        <el-tree
          class ="TreeBlock"
          :data="MangerData"
          :filter-node-method="filterNode"
          node-key="id"
          @node-click="TreeMangerClick"
          ref="tree"
          :props="defaultProps"
          default-expand-all:false
          :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogManager = false">取 消</el-button>
          <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择资产类别" :visible.sync="dialogProperty" width="35%">
        <el-tree
          class ="TreeBlock"
          :data="propertyData"
          :filter-node-method="filterNode"
          node-key="id"
          @node-click="TreePropertyClick"
          ref="tree"
          :props="propertyProps"
          default-expand-all:false
          :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogProperty = false">取 消</el-button>
          <el-button type="primary" @click="dialogProperty = false;">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%">
        <el-tree
          class ="TreeBlock"
          :data="PlaceData"
          :filter-node-method="filterNode"
          node-key="id"
          @node-click="TreePlaceClick"
          ref="tree"
          :props="defaultProps"
          default-expand-all:false
          :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogPlace = false">取 消</el-button>
          <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="根据单位查询" :visible.sync="dialogUnit" width="35%">
        <span>选择单位：</span>
        <el-select v-model.trim="unitData" placeholder="根据单位查询" @change="unitChange">
          <el-option
          v-for="i in DUnit"
          :label="i.unitName"
          :key="i.unitId"
          :value="i">
          </el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogUnit = false">取 消</el-button>
          <el-button type="primary" @click="dialogUnit = false;">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择是否为账外资产" :visible.sync="dialogIsNot" width="35%">
        <span>是否为账外资产：</span>
        <el-select v-model.trim="isNotData" @change="isNotChange" placeholder="请选择是否为账外资产">
          <el-option
            v-for="i in isNotList"
            :label="i.label"
            :key="i.value"
            :value="i">
          </el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogIsNot = false">取 消</el-button>
          <el-button type="primary" @click="dialogIsNot = false;">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择资产状态" :visible.sync="dialogStates" width="35%">
        <span>资产状态：</span>
        <el-select v-model.trim="statesData" @change="statesChange" placeholder="请选择资产状态">
          <el-option
            v-for="i in statesList"
            :label="i.label"
            :key="i.value"
            :value="i">
          </el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogStates = false">取 消</el-button>
          <el-button type="primary" @click="dialogStates = false;">确 定</el-button>
        </div>
      </el-dialog>

      <div class="property_index_search_button">
        <div class="property_index_search_button_item">
          <img src="../../assets/Property_Index_icon1.png" alt="" style="height: 36px; width: 40px; margin-left: 12px;" @click="dialogUpVisible = true">
          上传
        </div>
        <div class="property_index_search_button_item">
          <img src="../../assets/Property_Index_icon2.png" alt="" style="height: 36px; width: 40px; margin-left: 12px;" @click="Download()">
          导出
        </div>
        <!-- <div>
          <img src="../../assets/Property_Index_icon3.png" alt="" style="height: 36px; width: 40px; margin-left: 12px;" @click="dialogUpVisible = true">
          上传
        </div> -->
        <div class="property_index_search_button_item">
          <img src="../../assets/Property_Index_icon4.png" alt="" style="height: 36px; width: 40px; margin-left: 12px;" @click="deleteRow()">
          删除
        </div>
        <!-- <img src="../../assets/Property_Index_icon2.png" alt="" style="height: 36px; width: 40px; margin-left: 12px" @click="">
        <img src="../../assets/Property_Index_icon3.png" alt="" style="height: 36px; width: 40px; margin-left: 12px" >
        <img src="../../assets/Property_Index_icon4.png" alt="" style="height: 36px; width: 40px; margin-left: 12px" @click=""> -->
      </div>
      <!-- <div class="property_index_search_button">
        <el-button type="primary" @click="dialogUpVisible = true" icon="el-icon-upload" style="background-color: #fff; color: #4285F4; border: 0px; font-size: 24px;"></el-button>
        <el-button type="primary" @click="Download()" icon="el-icon-share" style="background-color: #fff; color: #4285F4; border: 0px; font-size: 24px;"></el-button>
        <el-button type="primary" icon="el-icon-plus" style="background-color: #fff; color: #4285F4; border: 0px; font-size: 24px;"></el-button>
        <el-button type="primary" @click="deleteRow()" icon="el-icon-delete" style="background-color: #fff; color: #E36060; border: 0px; font-size: 24px;"></el-button>
      </div> -->
    </div>
    <!-- 老刘代码 -->
    <!-- <el-container class="selectBlock">

      <el-col class="FirstBlock" :sapn="3" >
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
            <el-dropdown-item command="b">根据使用人姓名ID查询</el-dropdown-item>
            <el-dropdown-item command="c">根据资产固定编码查询</el-dropdown-item>
            <el-dropdown-item command="d">根据类别查询</el-dropdown-item>
            <el-dropdown-item command="e">根据存放的区域查询</el-dropdown-item>
            <el-dropdown-item command="f">根据单位查询</el-dropdown-item>
            <el-dropdown-item command="g">根据资产状态查询</el-dropdown-item>
            <el-dropdown-item command="h">根据是否为帐外资产查询</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>


          <el-input v-if="selectCheck == 'a'" v-model.trim="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>

          <el-input v-if="selectCheck == 'b'" v-model.trim="SForm.SownerId" :value="ManagerUser"  placeholder="根据使用人姓名ID查询">
              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogManager = true">选择</el-button> </el-input>



          <el-input v-if="selectCheck == 'c'" v-model.trim="SForm.SpropertyCode" placeholder="根据资产固定编码查询"></el-input>

          <el-input v-if="selectCheck == 'e'" v-model.trim="SForm.SplaceId" :value="SForm.SplaceRealId"
          append-to-body
          style="width: 250px;"
          placeholder="根据存放的区域查询">
              <el-button
                size="mini"
                 style="margin-top: 5px;"
                 slot="suffix"
                 type="text"
                @click="dialogPlace = true">选择</el-button></el-input>
                <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="PlaceData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePlaceClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPlace = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                  </div>
                </el-dialog>


          <el-input v-if="selectCheck == 'd'"  v-model.trim="SForm.SpropertyTypeId" placeholder="根据类别查询"></el-input>


          <el-select v-if="selectCheck == 'f'" v-model.trim="SForm.SunitId" placeholder="根据单位查询">
           <el-option
           v-for="i in DUnit"
           :label="i.unitName"
           :key="i.unitId"
           :value="i.unitId">
           </el-option>

           <el-select v-if="selectCheck == 'h'" v-model.trim="SForm.SoutProperty" placeholder="根据是否为帐外资产查询">
             <el-option label="是" value="1"></el-option>
             <el-option label="否" value="2"></el-option>
           </el-select>
          </el-select>


          <el-select v-if="selectCheck == 'g'" v-model.trim="SForm.SpropertyState" placeholder="是否为资产状态">
            <el-option label="在用" value='1'></el-option>
            <el-option label="待修" value='2'></el-option>
            <el-option label="在修" value='3'></el-option>
            <el-option label="备用" value='4'></el-option>
            <el-option label="闲置" value='5'></el-option>
            <el-option label="调剂" value='6'></el-option>
            <el-option label="待报废" value='7'></el-option>

            <el-option label="报废" value='8'></el-option>
            <el-option label="待确定" value='9'></el-option>
            <el-option label="在库" value='10'></el-option>

          </el-select>






        <el-button type="primary" @click="select(1)">查询</el-button>
        <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
      </el-col>

        <el-button type="info" @click="dialogUpVisible = true">导入</el-button>

        <el-dialog
          title="单个导入和批量导入"
          :visible.sync="dialogUpVisible"
          width="30%">
          <el-button type="danger" @click="UpOpen('单个导入','Property_Insert');dialogUpVisible = false">当个导入</el-button>
          <el-button type="danger" @click="UpOpen('批量导入','Property_Insert_More');dialogUpVisible = false">批量导入</el-button>
        </el-dialog>


        <el-button style="margin-left: 1%;" type="danger" @click="deleteRow()">删除</el-button>
        <el-button type="success" @click="Download()">导出</el-button>
    </el-container> -->
    <el-dialog
      title="单个导入和批量导入"
      :visible.sync="dialogUpVisible"
      width="30%">
      <el-button type="danger" @click="UpOpen('单个导入','PropertyInsert');dialogUpVisible = false">单个导入</el-button>
      <el-button type="danger" @click="UpOpen('批量导入','PropertyInsertMore');dialogUpVisible = false">批量导入</el-button>
    </el-dialog>

    <!-- 表格页 -->
    <div style=" padding-bottom: 50px;">
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        style="width: 98%;margin-left: 1%;">
        <el-table-column
              type="selection"
              width="55">
            </el-table-column>


        <el-table-column
          label="资产名称"
          prop="propertyName">
        </el-table-column>
        <el-table-column
          label="资产固定编码"
          prop="propertyCode"
          width="250">
        </el-table-column>
        <el-table-column
          label="资产状态"
          prop="propertyState"
          >
          <template slot-scope="scope">
            <!-- <el-tag
            :type="scope.row.propertyState == 1?''
            :(scope.row.propertyState==2?'success'
            :(scope.row.propertyState==3?'info'
            :(scope.row.propertyState==4?'danger'
            :(scope.row.properyState==5?''
            :(scope.row.properyState == 6?'success'
            :(scope.row.properyState==7?'info'
            :(scope.row.properyState==8?''
            :(scope.row.properyState==9?'warning'
            :(scope.row.properyState==10?'danger':'warning')))))))))"
            effect="dark"> -->
            <!-- <el-tag> -->
            <!-- <el-tag v-if="scope.row.propertyState == 1" style="background-color: rgba(66,133,244,0.2); color: #0D67FC;">在用</el-tag>
            <el-tag v-if="scope.row.propertyState == 2" style="background-color: rgba(205,21,21,0.2); color: #CD1515;">待修</el-tag>
            <el-tag v-if="scope.row.propertyState == 3" style="background-color: rgba(255,131,54,0.2); color: #FC6000;">在修</el-tag>
            <el-tag v-if="scope.row.propertyState == 4" style="background-color: rgba(68,177,134,0.2); color: #31986F;">备用</el-tag>
            <el-tag v-if="scope.row.propertyState == 5" style="background-color: rgba(255,131,54,0.2); color: #FC6000;">闲置</el-tag>
            <el-tag v-if="scope.row.propertyState == 6" style="background-color: rgba(68,177,134,0.2); color: #31986F;">调剂</el-tag>
            <el-tag v-if="scope.row.propertyState == 7" style="background-color: rgba(205,21,21,0.2); color: #CD1515;">待报废</el-tag>
            <el-tag v-if="scope.row.propertyState == 8" style="background-color: rgba(236, 238, 241,0.2); color: #818496;">报废</el-tag>
            <el-tag v-if="scope.row.propertyState == 9" style="background-color: rgba(205,21,21,0.2); color: #CD1515;">待确定</el-tag>
            <el-tag v-if="scope.row.propertyState == 10" style="background-color: rgba(66,133,244,0.2); color: #0D67FC;">在库</el-tag> -->
            <img src="../../assets/zaiyong.png" alt="" srcset="" v-if="scope.row.propertyState == 1">
            <img src="../../assets/daixiu.png" alt="" srcset="" v-if="scope.row.propertyState == 2">
            <img src="../../assets/zaixiu.png" alt="" srcset="" v-if="scope.row.propertyState == 3">
            <img src="../../assets/beiyong.png" alt="" srcset="" v-if="scope.row.propertyState == 4">
            <img src="../../assets/xianzhi.png" alt="" srcset="" v-if="scope.row.propertyState == 5">
            <img src="../../assets/tiaoji.png" alt="" srcset="" v-if="scope.row.propertyState == 6">
            <img src="../../assets/daibaofei.png" alt="" srcset="" v-if="scope.row.propertyState == 7">
            <img src="../../assets/yibaofei.png" alt="" srcset="" v-if="scope.row.propertyState == 8">
            <img src="../../assets/daiqueding.png" alt="" srcset="" v-if="scope.row.propertyState == 9">
            <img src="../../assets/zaiku.png" alt="" srcset="" v-if="scope.row.propertyState == 10">

            <!-- </el-tag> -->
          </template>
        </el-table-column>
        <el-table-column
          label="存放地点"
          prop="holdPlace">
        </el-table-column>
        <el-table-column
          label="资产类别"
          prop="propertyType">
        </el-table-column>
        <el-table-column
          label="使用人"
          prop="usedName">
        </el-table-column>
        
        <el-table-column
          label="部门"
          prop="usedDeptName">
        </el-table-column>
        <el-table-column
          label="数量"
          prop="propertyNum">
        </el-table-column>
        

        <el-table-column label="操作" align="center">
            <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="dialogFormEdit = true;handleEdit(scope.row)" style="color: #373737;">编辑</el-button>
                  <el-dialog title="修改资产" :visible.sync="dialogFormEdit" width="35%">
                    <PropertyEdit ref="child"></PropertyEdit>
                  </el-dialog>
                  <el-button type="text" @click="table = true">详情</el-button>
                  <el-drawer
                    title="资产详情"
                    :visible.sync="table"
                    direction="rtl"
                    size="50%">


                    <el-descriptions border :column="2" style="width: 95%;margin-left: 2%;">
                        <el-descriptions-item label="单位">{{scope.row.unitName}}</el-descriptions-item>

                        <el-descriptions-item label="规格">{{scope.row.propertySpecification}}</el-descriptions-item>

                        <el-descriptions-item label="资产类别Id">{{scope.row.propertyTypeId}}</el-descriptions-item>
                        <el-descriptions-item label="存放区域ID">{{scope.row.placeId}}</el-descriptions-item>

                        <el-descriptions-item label="存放地点">{{scope.row.holdPlace}}</el-descriptions-item>
												<el-descriptions-item label="取得方式">{{scope.row.gainMethod}}</el-descriptions-item>
												<el-descriptions-item label="取得日期">{{scope.row.gainDate}}</el-descriptions-item>

                        <el-descriptions-item label="管理员部门名称">{{scope.row.managerDeptName}}</el-descriptions-item>

                        <el-descriptions-item label="管理员名称">{{scope.row.managerName}}</el-descriptions-item>
                        <!-- <el-descriptions-item label="帐外资产">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.outProperty == 1">是</div>
                                    <div v-if="scope.row.outProperty == 2">否</div>
                                </template></el-descriptions-item> -->
						<el-descriptions-item label="凭证号">{{scope.row.voucher}}</el-descriptions-item>
                        <el-descriptions-item label="供应商">{{scope.row.supplier}}</el-descriptions-item>

                    </el-descriptions>
                  </el-drawer>
              </template>
            </el-table-column>
      </el-table>

      <el-pagination
           @size-change="handleSizeChange"
           @current-change="select"
           :current-page="currentPage"
           :page-sizes="[10, 20, 50, 100]"
           :page-size="pageSize"
           layout="total, sizes, prev, pager, next, jumper"
           :total="total">
         </el-pagination>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import PropertyEdit from "./Property_Edit.vue"
  import { Loading } from 'element-ui'
  import qs from "qs"
  export default {
     name: 'Property_Index',
     components:{
       PropertyEdit
     },
  data () {
  const PlaceData = [{
          id: 1,
          label: '一级 1',
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        }];

    return {
      searchData: '', //输入框值
      selectSearchData: '', //选择框值
      //选择人员
      dialogManager: false,
      //选择存放区域
      dialogPlace:false,
      //选择单位
      dialogUnit:false,
      dialogProperty:false,
      unitData: '',
      //选择是否为账外资产
      dialogIsNot: false,
      isNotData: '',
      isNotList: [
        {label: '是', value: '1'},
        {label: '否', value: '2'},
      ],
      //选择资产状态
      dialogStates: false,
      statesData: '',
      statesList: [
        {label: '在用', value: '1'},
        {label: '待修', value: '2'},
        {label: '在修', value: '3'},
        {label: '备用', value: '4'},
        {label: '闲置', value: '5'},
        {label: '调剂', value: '6'},
        {label: '待报废', value: '7'},
        {label: '报废', value: '8'},
        {label: '待确定', value: '9'},
        {label: '在库', value: '10'},
      ],
      propertyData: [],


        dialogUpVisible :false,
        selectCheck:'',
        ManagerUser:'',
        multipleSelection: [],

        table: false,
        dialog: false,

        dialogOut:false,

        currentPage: 1,
        pageSize:20,
        total:0,
        dialogOutPlace:false,
        PlaceId:'',
        dialogFormEdit:false,
        MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
        SForm:{
          SpropertyName:'',
          SpropertyCode:'',
          SpropertyTypeId:'',
          SplaceId:'',
          SownerId:'',
          SunitId:'',
          SpropertyState:'',
          SoutProperty:'',
          SplaceRealId:"",
        },

      drawer: false,
      direction: 'rtl',


      OutpropertyName:'',
      OutpropertyCode:'',
      OutpropertyTypeId:'',
      OutPlaceId:'',
      OutownerName:'',
      OutunitId:'',


      PlaceData: JSON.parse(JSON.stringify(PlaceData)),

      DName:[{
        departmentId:'',
        departmentName:'',
      }],
      DUnit:[{
        unitName:'',
        unitId:'',
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      propertyProps: {
          children: 'children',
          label: 'sortName'
        },
      fileName:'导出文件',
      tableData:[{
        createDate:'',
        epc:'',
        supplier:'',
        del:'',
        holdPlace:'',
        managerDeptId:'',
        managerDeptName:'',
        managerId:'',
        managerName:'',
        mgrName:'',
        outProperty:'',
        ownerDeptId:'',
        ownerId:'',
        placeId:'',
        propertyCode:'',
        propertyId:'',
        propertyModel:'',
        propertyName:'',
        propertyRfid:'',
        propertySpecification:'',
        propertyState:'',
        propertyType:'',
        propertyTypeId:'',
        unitId:'',
        unitName:'',
        usedDeptName:'',
        updateDate:'',
        usedName:'',

      }]
      };
    },
    created:function() {
		// 首先是当页面加载的时候自动渲染这些数据

		// 加载同时加载子页面
       this.$refs.child
	   // 表格里面的数据
       this.showData();
	   // 查询条件里面的数据预加载    部门信息
       this.showDepartmentData();
	   // 查询条件里面的数据预加载    单位信息
       this.showUnitData();
	   // 查询条件里面的数据预加载    人员信息
       this.showMData();
	   // 查询条件里面的数据预加载    区域信息
       this.showPlaceData();
       this.showProperty()
     },
     watch: {
		 // 树状结构的显示核心
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },

    methods: {
    // 重置数据
    resetForm(formName) {
      Object.assign(this.$data.SForm, this.$options.data().SForm)
      this.searchData = ''
      this.ManagerUser =0
      this.select()
    },
    // 根据条件查询查询数据都在SForm中

    // 将input输入框的值赋予对应位置
    inputValueChange() {
      // console.log(this.selectSearchData)
      switch (this.selectSearchData) {
        case '1' :
          this.SForm.SpropertyName = this.searchData
          break
        case '2' :
          this.SForm.SownerId = this.searchData
          break
        case '3' :
          this.SForm.SpropertyCode = this.searchData
          break
        case '4' :
          this.SForm.SpropertyTypeId = this.searchData
          break
        case '5' :
          this.SForm.SplaceId = this.searchData
          break
        case '6' :
          this.SForm.SunitId = this.searchData
          break
        case '7':
          this.SForm.SoutProperty = this.searchData
          break
        case '8' :
          this.SForm.SpropertyState = this.searchData
          break
      }
    },

    // 如果不是输入则改变方式
    getValueMethods() {
      // console.log(this.selectSearchData === 2)
      // if() {

      // }
      switch (this.selectSearchData) {
        case '2':
          this.dialogManager = true
          break
        case '4':
          this.dialogProperty = true
          break
        case '5':
          this.dialogPlace = true
          break
        case '6':
          this.dialogUnit = true
          break
        case '7':
          this.dialogIsNot = true
          break
        case '8':
          this.dialogStates = true
          break
      }
    },
    //选择其他搜索条件时清除之前的数据
    // rightSelectSearchChange() {
    //   this.resetForm('SForm')

    // },

    //
    unitChange(e) {
      this.SForm.SunitId = e.unitId
      this.searchData = e.unitName
    },
    statesChange(e) {
      this.SForm.SpropertyState = e.value
      this.searchData = e.label
    },
    isNotChange(e) {
      this.SForm.SoutProperty = e.value
      this.searchData = e.label
    },

    //获取资产类别
    showProperty() {
      let data = {
        unitId:Cookies.get("UnitId"),
        // del:1
        sortMgr: '',
      }
      console.log(data)
      this.axios({
        method: 'GET',
        url: '/propertySort/showPropertySortDetail', 
        params: data,         
      }).then((res)=>{
        this.propertyData=res.data.data;
      })
    },
	handleSizeChange(val){
		this.pageSize = val
		this.select()
	},
    select(val){
      var authorization = Cookies.get("Authorization");
      this.currentPage  = val
      var paramsData = {
        currentPage: val || 1 ,
        del:1,
        pageSize: this.pageSize,
        propertyName:this.SForm.SpropertyName || undefined,
        propertyCode:this.SForm.SpropertyCode || undefined,
        propertyTypeId:this.SForm.SpropertyTypeId || undefined,
        placeId:this.SForm.SplaceRealId || undefined,
        ownerId:this.ManagerUser || undefined,
        unitId:this.SForm.SunitId || undefined,
        propertyState:this.SForm.SpropertyState || undefined,
        outProperty:this.SForm.SoutProperty || undefined,
      }

        this.axios({
            method: 'GET',
            url: '/property/showPropertyMsg',
            params:paramsData,
            header:{
            'Authorization':authorization,
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
          }).then((resp)=>{
            this.tableData=resp.data.data;
            this.total = resp.data.count;
          })
    },
    // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
    TreePlaceClick(data){
      this.SForm.SplaceRealId = data.id
      this.SForm.SplaceId = data.label
      this.searchData = data.label
    },
    // 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID
      TreeMangerClick(data){
          this.ManagerUser = data.realId
          this.searchData = data.label
      },
      TreePropertyClick(data) {
        console.log(data)
        this.SForm.SpropertyTypeId = data.sortId
        this.searchData = data.sortName
      },
      // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreeOutPlaceClick(data){
          this.OutPlaceId = data.label
      },

      filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },

    // 请求小杜接口public/getTree获取区域信息然后将数据传给MangerData在37行
      showMData(){
      var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'GET',
            url: '/public/getUnitTree',
            header:{
            'Authorization':authorization,
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
          }).then((resp)=>{

          var arr = new Array(resp.data.data) ;
          this.MangerData=resp.data.data;
          this.UserData = resp.data.data;
          })
      },
    // 请求小杜接口public/getTree获取区域信息然后将数据传给PlaceData在221行
      showPlaceData(){
      var authorization = Cookies.get("Authorization");
      var params = {
        currentPage: 1,
        pageSize: 5,
        unitId: Cookies.get('unitId')
      }
        this.axios({
            method: 'GET',
            url: '/public/getPlaceTreeV2',

            header:{
            'Authorization':authorization,
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
          }).then((resp)=>{

          this.PlaceData=resp.data.data;
          })
      },

  // 打开批量和单个导入的界面
    UpOpen(targetName,components){
        this.$parent.$parent.$parent.$parent.$parent.$parent.addTab(targetName,components)
    },
  // 请求小杜接口/public/getCanHandleDepartmentList获取部门信息然后将数据传给DName在149行使用
      showDepartmentData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 5,
        }
        this.axios({
            method: 'GET',
            url: '/public/getCanHandleDepartmentList',
            params:params,
            header:{
              'Authorization':authorization,
              'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              }
          }).then((resp)=>{
            this.DName = resp.data.data;

          })
      },





  // 请求小杜接口/public/getCanWatchUnit获取单位信息然后将数据传给DUnit在96行
      showUnitData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 5,
        }
        this.axios({
            method: 'GET',
            url: '/public/getCanWatchUnit',
            params:params,
            header:{
              'Authorization':authorization,
              'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              }
          }).then((resp)=>{
            this.DUnit = resp.data.data;
          })
      },


  // 主要数据展示给tableData
      showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          del:1,
          currentPage: 1,
          pageSize: 20,
        }
		const options={
			text:'正在加载',
			spinner:'el-icon-loading'
		}
		let loadingInstance = Loading.service(options);
          this.axios({
              method: 'GET',
              url: '/property/showPropertyMsg',
              params:params,
              header:{
              'Authorization':authorization,
              'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              }
            }).then((resp)=>{
			if(resp.data.code == 200){
				this.$nextTick(() => {
					// 以服务的方式调用的 Loading 需要异步关闭
					loadingInstance.close();
					});
					this.tableData = resp.data.data;
					this.total = resp.data.count;
			}
            })
          },
    // 多选框选中的数据
          handleSelectionChange(val) {
              this.multipleSelection = val;
                },
    // 按照条件批量导出功能
        Download(){
          var data ={
            propertyName:this.SForm.SpropertyName|| null,
            propertyCode:this.SForm.SpropertyCode|| null,
            propertyTypeId:parseInt(this.SForm.SpropertyTypeId)|| undefined,
            placeId:parseInt(this.SForm.SplaceRealId)|| undefined,
            ownerId:parseInt(this.SForm.SownerId)|| undefined,
            unitId:parseInt(this.SForm.SunitId)|| undefined,
          }
          this.axios({
            method: 'POST',
            url: '/property/exportExcelBigData',
            data:data,
          }).then((res)=>{
            // console.log(res)
            if(res.data.code === 200) {
              location.href = res.data.data
            }
          })
          // function removeEmptyValues(obj) {
          //     for (const key in obj) {
          //         if (typeof obj[key] === 'object') {
          //             removeEmptyValues(obj[key]);
          //         }

          //         if (!obj[key] || (typeof obj[key] === 'object' && !Reflect.ownKeys(obj[key]).length)) {
          //             delete obj[key];
          //         }
          //     }
          // }
          removeEmptyValues(data)
          var authorization = Cookies.get("Authorization");
              // http://192.168.100.225:8999
              fetch('/apiYang/property/exportExcelBigData?'+new URLSearchParams(data), {
                  method: 'GET',
                  // body:params,
                  headers:{
                    'Content-Type': 'application/json',
                    'Authorization': authorization
                  },
              })
              .then(res => res.blob())
              .then(data => {
                  const blobUrl = window.URL.createObjectURL(data);
                  const a = document.createElement('a');
                  a.download = this.fileName+'.xlsx';
                  a.href = blobUrl;
                  a.click();
          });
        },
    // 下拉菜单存放点击时选中的数据
        handleCommand(command) {

                this.selectCheck = command
              },


        open2(val) {
                this.$message({
                  message: val,
                  type: 'success',
				  duration: 3000
                });
              },

    // 打开子组件编辑的页面
          handleEdit(rows) {
            this.$nextTick(()=>{
              this.$refs.child.showIndexData(rows)
            })
                },
      // 批量选中删除
                deleteRow(){
                      var authorization = Cookies.get("Authorization");
                      var deleteData = []
                      for(let i of this.multipleSelection){
                        deleteData.push(i.propertyId)
                      }



                      this.axios({
                          method: 'POST',
                          url: '/property/del',
                          params:{
                            ids:deleteData
                          },
                          paramsSerializer:params =>{
                            return qs.stringify(params,{indices:false})
                          },
                          header:{
                            'Authorization':authorization,
                            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                            }
                        }).then((res)=>{
                            // this.open2('删除成功')
                            if(res.data.code == 200) {
                              this.showData()
                              this.$message.success('删除成功')
                            } else {
                              this.$message.error(res.data.message)
                            }

                        })
                    },






    }
  }
</script>

<style lang="less">

  .property_index {
    background: #fff;
    width: 1650px;
    // display: flex;
    // justify-content: space-between;

    .property_index_search {

      color: #7F8F9B !important;
      display: flex;
      justify-content: space-between;

      .property_index_search_input {
        // width: 850px;
        padding: 24px 60px;
        border-radius: 30px;
        display: flex;
        justify-content: space-between;

        .property_index_search_input_text {
          line-height: 45px;
          margin-left: 24px;
          color: #121212;
          font-size: 16px;
        }
      }

      .property_index_search_button {
        margin: 24px 50px 0 0;
        display: flex;
        justify-self: start;

        .property_index_search_button_item {
          display: flex;
          flex-direction: column;
          text-align: center;
        }
      }
      .el-input__inner {
        background: #F5F5F5 !important;
        border: 30px;
        // border-radius: 30px 0 0 30px;
        color: #7F8F9B;
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Index.vue